import { useIsMobile } from "@brg/ui";
import { useCallback, useEffect, useMemo, useState } from "react";

const DEFAULT_HEIGHT_LINES = 5;
const DEFAULT_HEIGHT_LINES_MOBILE = 10;

const useTextHeight = (containerRef: React.RefObject<HTMLDivElement>) => {
  const [height, setHeight] = useState(0);
  const [overflow, setOverflow] = useState(0);
  const [metrics, setMetrics] = useState<{ height: number, lines: number, lineHeight: number } | null>(null);
  const [annotationHeight, setAnnotationHeight] = useState(0);
  const isMobile = useIsMobile();

  useEffect(() => {
      setOverflow((containerRef.current?.scrollHeight || 0) - (containerRef.current?.clientHeight || 0));
  }, []);

  const getMeasures = useCallback((metrics: { height: number, lines: number, lineHeight: number }) => {
    setMetrics(metrics);
  }, []);

  useEffect(() => {
    if (!!annotationHeight || !metrics) return;
    if (containerRef.current?.clientHeight === 0) {
      const lineHeight = isMobile ? DEFAULT_HEIGHT_LINES_MOBILE : DEFAULT_HEIGHT_LINES;
      return setAnnotationHeight(lineHeight);
    }
    const finalOverflow = overflow || (metrics?.height - (containerRef.current?.clientHeight || 0));
    const overflowingLines = finalOverflow > 0 ? Math.ceil(finalOverflow / (metrics?.lineHeight || 0)) : 0;
    setAnnotationHeight((metrics?.lines || 0) - overflowingLines);
  }, [metrics, overflow, isMobile]);

  return { getMeasures, annotationHeight };
};

export default useTextHeight;import { useIsMobile } from "@brg/ui";
import { useCallback, useEffect, useMemo, useState } from "react";

const DEFAULT_HEIGHT_LINES = 5;
const DEFAULT_HEIGHT_LINES_MOBILE = 10;

const useTextHeight = (containerRef: React.RefObject<HTMLDivElement>) => {
  const [height, setHeight] = useState(0);
  const [overflow, setOverflow] = useState(0);
  const [metrics, setMetrics] = useState<{ height: number, lines: number, lineHeight: number } | null>(null);
  const [annotationHeight, setAnnotationHeight] = useState(0);
  const isMobile = useIsMobile();

  useEffect(() => {
      setOverflow((containerRef.current?.scrollHeight || 0) - (containerRef.current?.clientHeight || 0));
  }, []);

  const getMeasures = useCallback((metrics: { height: number, lines: number, lineHeight: number }) => {
    setMetrics(metrics);
  }, []);

  useEffect(() => {
    if (!!annotationHeight || !metrics) return;
    if (containerRef.current?.clientHeight === 0) {
      const lineHeight = isMobile ? DEFAULT_HEIGHT_LINES_MOBILE : DEFAULT_HEIGHT_LINES;
      return setAnnotationHeight(lineHeight);
    }
    const finalOverflow = overflow || (metrics?.height - (containerRef.current?.clientHeight || 0));
    const overflowingLines = finalOverflow > 0 ? Math.ceil(finalOverflow / (metrics?.lineHeight || 0)) : 0;
    setAnnotationHeight((metrics?.lines || 0) - overflowingLines);
  }, [metrics, overflow, isMobile]);

  return { getMeasures, annotationHeight };
};

export default useTextHeight;